import axios from 'axios';
const API_URL = process.env.REACT_APP_API;
const IMG_API_URL = process.env.REACT_APP_PUBLIC;

export async function getAllNotices() {
  const response = await axios.get(`${API_URL}catalogos/notice`);
  const data = response.data.doc.data;
  return data;
}

export async function updNotice(values: any) {
  const body = { ...values };

  const formData = new FormData();

  if (body.title) {
    formData.append('title', body.title);
  }
  if (body.description) {
    formData.append('description', body.description);
  }
  if (body.show_app !== undefined && body.show_app !== null) {
    formData.append('is_active', body.show_app.toString());
  }
  if (body.file instanceof File) {
    formData.append('additionalFile', body.file);
  }
  if (body.image instanceof File) {
    formData.append('carousel_image', body.image);
  }
  if (body.is_current) {
    formData.append('is_current', body.is_current.toString());
  }
  const response = await axios({
    method: 'put',
    url: `${API_URL}catalogos/notice/${body.id_aviso}`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response;
}

export async function getDoc(id: number) {
  const response = await axios.get(`${API_URL}catalogos/notice/download/${id}`);
  const data = response.data.doc.data;
  return data;
}

export async function getAvisoImageUrl(
  filename: string
): Promise<string | null> {
  if (!filename) return null;

  const token = localStorage.getItem('token');
  try {
    const response = await axios.get(`${IMG_API_URL}notices/${filename}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });

    return URL.createObjectURL(response.data);
  } catch (error) {
    console.error('Error al obtener imagen protegida:', error);
    return null;
  }
}
